import React from "react"
import { Form } from "react-final-form"

import { styled } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { resetPasswordConfirmErrorTranslationKeys, ResetPasswordConfirmFormFieldNames } from "./types"
import { useSubmitHandler } from "./useSubmitHandler"
import {
  FormTitle, PasswordField, StyledLoginForm, SubmitButton
} from "../../components"
import { Grid } from "../../containers"

export const ResetPasswordConfirmForm = ({ executeOnSuccess }) => {
  const { i18n } = useTranslations()
  const {
    submitting, error, handleSubmit, cleanError
  } = useSubmitHandler(executeOnSuccess)

  return <Form onSubmit={handleSubmit}
               render={({ handleSubmit, values: { newPassword, newPasswordConfirm } }) => <StyledLoginForm
                 onSubmit={handleSubmit}>
                 <Grid>
                   <FormTitle
                     sx={{ marginBottom: "10px" }}>{i18n("Account.RestoreForgottenPassword:PasswordReset")}</FormTitle>

                   <Text>{i18n("Account.RestoreForgottenPassword:PasswordRule")}</Text>

                   <FieldsContainer>
                     <PasswordField name={ResetPasswordConfirmFormFieldNames.newPassword} textFieldProps={{
                       error: !!error,
                       placeholder: i18n("User:EnterNewPassword"),
                       disabled: submitting,
                       executeOnChange: cleanError
                     }}/>
                     <PasswordField name={ResetPasswordConfirmFormFieldNames.newPasswordConfirm} textFieldProps={{
                       error: !!error,
                       placeholder: i18n("User:ConfirmNewPassword"),
                       disabled: submitting,
                       executeOnChange: cleanError,
                       helperText: !!error && <ErrorHelperText errorTranslationKey={error}/>
                     }}/>
                   </FieldsContainer>
                 </Grid>

                 <SubmitButton label={i18n("Account.RestoreForgottenPassword:Reset")} type="submit"
                               isLoading={submitting}
                               disabled={!!error || submitting || !newPassword?.trim() || !newPasswordConfirm?.trim()}/>
               </StyledLoginForm>}/>
}

const Text = styled("div")({
  fontSize: "14px", fontWeight: 400, lineHeight: "21px", letterSpacing: 0,
})

const FieldsContainer = styled("div")({
  display: "grid", rowGap: "30px", padding: "16px 0"
})

const ErrorHelperText = ({ errorTranslationKey }: { errorTranslationKey: string }) => {
  const { i18n } = useTranslations()
  const message = errorTranslationKey === resetPasswordConfirmErrorTranslationKeys.InvalidLength
    ? i18n(resetPasswordConfirmErrorTranslationKeys.InvalidLength).replace("{0}", "5")
    : i18n(errorTranslationKey)

  return <div>{message}</div>
}